export class ContactPersonModel{
    contactPersonId: string;
    name: string;
    position: string;
    phoneNumber: string;
    email: string;
    contactPersonImage: string;
    contactImageUrl: string;
    contactIsrepresentative: boolean;
    companyName: string;
    deleteStatus: boolean;

    constructor(){
        this.contactPersonId="";
        this.name="";
        this.position="";
        this.phoneNumber="";
        this.email="";
        this.contactPersonImage= "";
        this.contactImageUrl = "";
        this.contactIsrepresentative=false;
        this.companyName= "";
        this.deleteStatus = false;
    }
}